import React from 'react'
import { AiOutlineExclamationCircle } from 'react-icons/ai'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import * as indicacaoActions from 'store/modules/indicacao/actions'
import { removeMaskCPF } from 'util/masks'
import useRedux from 'hooks/useRedux'

interface PropostaIndicacaoManualProps {
  isOpen: boolean
  toggle: () => void
  cpf: string
}

const PropostaIndicacaoManual = ({
  isOpen,
  toggle,
  cpf
}: PropostaIndicacaoManualProps) => {
  const { dispatch } = useRedux()

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader toggle={() => toggle()}>
        <SimpleTitleCard colorIcon="F7931E">
          <AiOutlineExclamationCircle className="icon" />
          Deseja criar indicação?
        </SimpleTitleCard>
      </ModalHeader>
      <ModalBody>
        <div className="d-flex flex-column gap-3 align-items-center">
          <CustomButton
            onClick={() => {
              dispatch(
                indicacaoActions.criarPropostaIndicacaoManualSaga(
                  removeMaskCPF(cpf)
                )
              )
              toggle()
            }}
          >
            CRIAR INDICAÇÃO
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default PropostaIndicacaoManual
